import { ShowHide } from "components/layout";
import { TypesOfCoverRecord } from "pages/licence-checking/grey-fleet/shared";
import PropTypes from "prop-types";
import React, { Fragment } from "react";

const defaultArray = [];
const columnsWithRequiredCover = 6;
const columnsWithoutRequiredCover = 5;

// True once the check has recorded the cover the company required and at least one of those types
// still resolves in the lookup. A required type retired from the lookup cannot be named, and a dash
// under the header would read as "no cover required", which is a different thing entirely.
export function hasRequiredCover(userInput, coverTypes = defaultArray) {
    if (
        !Array.isArray(userInput?.requiredCoverTypeIds) ||
        !Array.isArray(coverTypes)
    ) {
        return false;
    }

    return userInput.requiredCoverTypeIds.some((coverTypeId) =>
        coverTypes.some((coverType) => coverType.id === coverTypeId)
    );
}

// The grid holding the cover block gains a column when the required cover is shown beside the
// declared cover.
export function getCoverRecordsColumnCount(userInput, coverTypes = defaultArray) {
    if (hasRequiredCover(userInput, coverTypes)) {
        return columnsWithRequiredCover;
    }

    return columnsWithoutRequiredCover;
}

// The cover the company required beside the cover the driver declared, so the two can be compared
// side by side. Checks that specify no required cover keep the single declared cover block.
export function GreyFleetInsuranceCoverRecords(
    {
        loading,
        userInput = null,
        coverTypes = defaultArray
    }
) {
    return (
        <ShowHide
            evaluator={hasRequiredCover(userInput, coverTypes)}
            show={
                <Fragment>
                    <TypesOfCoverRecord
                        loading={loading}
                        header="Required type(s) of cover"
                        coverTypeIds={userInput?.requiredCoverTypeIds}
                        coverTypes={coverTypes}
                    />
                    <TypesOfCoverRecord
                        loading={loading}
                        header="Declared type(s) of cover"
                        coverTypeIds={userInput?.coverTypeIds}
                        coverTypes={coverTypes}
                        legacyBusinessUse={userInput?.businessUse}
                    />
                </Fragment>
            }
            hide={
                <TypesOfCoverRecord
                    loading={loading}
                    coverTypeIds={userInput?.coverTypeIds}
                    coverTypes={coverTypes}
                    legacyBusinessUse={userInput?.businessUse}
                />
            }
        />
    );
}

GreyFleetInsuranceCoverRecords.propTypes = {
    loading: PropTypes.bool.isRequired,
    userInput: PropTypes.object,
    coverTypes: PropTypes.array
};
